import { GATrackEvent } from 'utils/googleAnalytics'

import type { BaseWidget } from './typings'

export enum NON_GENERAL_WIDGET {
  Assessment = 'Assessment',
  Toolkit = 'Toolkit',
  Topic = 'Topic',
  Module = 'Module',
  AksiNyata = 'AksiNyata',
  PageCard = 'PageCard',
}

type TAssessmentParams = { type: NON_GENERAL_WIDGET.Assessment; id: string }
type TToolkitParams = { type: NON_GENERAL_WIDGET.Toolkit; id: string }
type TTopicParams = { type: NON_GENERAL_WIDGET.Topic; id: string }
type TModuleParams = {
  type: NON_GENERAL_WIDGET.Module
  id: string
  topicId?: number
  topicName?: string
}
type TAksiNyataParams = {
  type: NON_GENERAL_WIDGET.AksiNyata
  id: string
  topicId?: number
  topicName?: string
}
type TPageCardParams = { type: NON_GENERAL_WIDGET.PageCard; id: string }

type TGetUrlParams =
  | TAssessmentParams
  | TToolkitParams
  | TTopicParams
  | TModuleParams
  | TAksiNyataParams
  | TPageCardParams

export const getNonGeneralWidgetUrl: (
  params: TGetUrlParams
) => string | null = (params) => {
  const baseUrl = process.env.NEXT_PUBLIC_BASE_URL
  switch (params.type) {
    case NON_GENERAL_WIDGET.Assessment:
      return `${baseUrl}/assessment/litnum/${params.id}`
    case NON_GENERAL_WIDGET.Toolkit:
      return `${baseUrl}/perangkat-ajar/toolkits/${params.id}`
    case NON_GENERAL_WIDGET.Topic:
      return `${baseUrl}/${
        process.env.NEXT_PUBLIC_TEMP_PELATIHAN_MANDIRI_PATH ||
        'pelatihan-mandiri'
      }/topik/${params.id}`
    case NON_GENERAL_WIDGET.Module:
      return `${baseUrl}/${
        process.env.NEXT_PUBLIC_TEMP_PELATIHAN_MANDIRI_PATH ||
        'pelatihan-mandiri'
      }/modul/${params.id}${
        !!params.topicId && !!params.topicName
          ? `?topik=${params.topicId}&topik_name=${params.topicName}`
          : ''
      }`
    case NON_GENERAL_WIDGET.AksiNyata:
      return `${baseUrl}/${
        process.env.NEXT_PUBLIC_TEMP_PELATIHAN_MANDIRI_PATH ||
        'pelatihan-mandiri'
      }/aksi-nyata/${params.id}${
        !!params.topicId && !!params.topicName
          ? `?topik=${params.topicId}&topik_name=${params.topicName}`
          : ''
      }`
    case NON_GENERAL_WIDGET.PageCard:
      return `${baseUrl}/${
        process.env.NEXT_PUBLIC_TEMP_PELATIHAN_MANDIRI_PATH ||
        'pelatihan-mandiri'
      }/contextualized-learning/${params.id}`
    default:
      return null
  }
}

export const trackWidgetClick = (params: BaseWidget['trackerWidgetData']) => {
  GATrackEvent({
    eventName: 'contextualized_learning',
    eventParams: {
      event_trigger: 'click_widget',
      action_type: `click_widget_from_${params.source}`,
      kb_id: params.kbPageId,
      widget_type: params.widgetType,
      widget_id: params.widgetId,
      widget_title:
        params.widgetValue.title || params.widgetValue.label || null,
      target_url: params.widgetValue.url || null,
    },
    sendDefaultParams: true,
  })
}
